import { HttpService } from "@/core";
import {
  CompanyTypePageReq,
  CompanyTypePageResp,
  CompanyTypeDetailResp,
  CompanyTypeReq,
  CompanyTypeSimpleListResp,
} from "./company-type.interface";

export class CompanyTypeService {
  static usePageApi() {
    const api = (params: CompanyTypePageReq) =>
      HttpService.axios({
        method: "GET",
        url: "/cooperation_company_type/page",
        params,
      });
    return HttpService.usePagination<CompanyTypePageResp>(api);
  }

  static useSimpleListApi() {
    const api = (params) =>
      HttpService.axios({
        method: "GET",
        url: "/cooperation_company_type/simple/list",
        params
      });
    return HttpService.useRequest<CompanyTypeSimpleListResp>(api);
  }

  static useDetailApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "GET",
        url: `/cooperation_company_type/${id}`,
      });
    return HttpService.useRequest<CompanyTypeDetailResp>(api);
  }

  static useCreateApi() {
    const api = (data: CompanyTypeReq) =>
      HttpService.axios({
        method: "POST",
        url: "/cooperation_company_type",
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useEditApi() {
    const api = (id: string, data: CompanyTypeReq) =>
      HttpService.axios({
        method: "PUT",
        url: `/cooperation_company_type/${id}`,
        data,
      });
    return HttpService.useRequest<void>(api);
  }

  static useDeleteApi() {
    const api = (id: string) =>
      HttpService.axios({
        method: "DELETE",
        url: `/cooperation_company_type/${id}`,
      });
    return HttpService.useRequest<void>(api);
  }
}
